import { Box, Button, Text } from "@saleor/macaw-ui-next";
import { ChevronLeft, ChevronRight } from "lucide-react";
import React from "react";

interface PaginationProps {
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  onNext: () => void;
  onPrevious: () => void;
  disabled?: boolean;
}

export const Pagination: React.FC<PaginationProps> = ({
  hasNextPage,
  hasPreviousPage,
  onNext,
  onPrevious,
  disabled = false,
}) => {
  if (!hasNextPage && !hasPreviousPage) {
    return null;
  }

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      gap={2}
      paddingY={3}
    >
      <Button
        variant="tertiary"
        size="small"
        onClick={onPrevious}
        disabled={!hasPreviousPage || disabled}
      >
        <Box display="flex" alignItems="center" gap={1}>
          <ChevronLeft size={14} />
          <Text size={2}>Previous</Text>
        </Box>
      </Button>
      <Button
        variant="tertiary"
        size="small"
        onClick={onNext}
        disabled={!hasNextPage || disabled}
      >
        <Box display="flex" alignItems="center" gap={1}>
          <Text size={2}>Next</Text>
          <ChevronRight size={14} />
        </Box>
      </Button>
    </Box>
  );
};
